import {
  GET_EVENTS,
  ERROR_EVENT,
  UPDATE_EVENT,
  DELETE_EVENT,
  GET_EVENT,
  ADD_EVENT,
} from "../actions/types";

const inialState = {
  events: [],
  event: null,
  loading: true,
  error: {},
};

export default function (state = inialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_EVENT:
      return {
        ...state,
        event: payload,
        loading: false,
      };

      case ADD_EVENT:
      return {
        ...state,
        events: [payload, ...state.events],
        loading: false,
      };
    
    case GET_EVENTS:
      return {
        ...state,
        events:  payload,
        loading: false,
      };

    case UPDATE_EVENT:
      return {
        ...state,
        events: state.events.map((event) =>
          event._id === payload._id ? payload : event
        ),
        loading: false,
      };
    case DELETE_EVENT:
      return {
        ...state,
        events: state.events.filter((event) => event._id !== payload),
        loading: false,
      };
    case ERROR_EVENT:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    default:
      return state;
  }
}
